const dpPlan = (() => {
  const pageDinksPets = (document.getElementById("pageDinksPets") != null);
  if (pageDinksPets) {


    let sW = window.innerWidth;

    let centeredSlides;
    let slidesPerView;
    let spaceBetween;

    if (sW > 750) {
      centeredSlides = false
      slidesPerView = 1.0
      spaceBetween = 40
    } else {
      centeredSlides = true
      slidesPerView = 1.3
      spaceBetween = 20
    }

    const swiper = new Swiper("#jsSwiperPlan", {
      loop: true,
      centeredSlides: centeredSlides,
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      speed: 800,
      navigation: {
        nextEl: ".swiper-btn-next",
        prevEl: ".swiper-btn-prev"
      }
    });

    let swiperCopy = document.getElementById("jsSwiperPlanCopy")
    let num = swiperCopy.querySelector('.js-num');
    let ttl = swiperCopy.querySelector('.js-ttl');
    let txt = swiperCopy.querySelector('.js-txt');
    swiper.on('slideChange', function () {
      if (swiper.realIndex == 0) {
        num.textContent = `#1`;
        ttl.textContent = `キッチン`;
        txt.textContent = `家のほぼ中心にあるキッチンは、ダイニングとリビング、ペットルームまで視界が届き、立つのが楽しくなるお気に入りの場所。動線を考えた2WAYスタイルは思った以上の使いやすさで、スムーズな回遊性が抜群。`;
      } else if (swiper.realIndex == 1) {
        num.textContent = `#2`;
        ttl.textContent = `ペットルーム`;
        txt.textContent = `愛犬・愛猫が快適に過ごせる専用ルームを確保。落ち着いてくつろげるようインテリアやクロスを工夫できたし、リビングとつながる窓から中の様子を確認できたり、上部が開くので空調も安心。みんな居心地は良さそう。`;
      } else if (swiper.realIndex == 2) {
        num.textContent = `#3`;
        ttl.textContent = `洋室1`;
        txt.textContent = `大きめのベッドを置いても広さに余裕がある寝室。夫がDIYしたサイドテーブルが部屋の雰囲気を高めてくれる。休日の朝、ここでゆっくり一日の予定を決める時間は、2人にとって大切なコミュニケーション。`;
      } else if (swiper.realIndex == 3) {
        num.textContent = `#4`;
        ttl.textContent = `洋室2`;
        txt.textContent = `夫自慢のDIYギアが並ぶ洋室は、趣味の部屋に。DIYルームで作った家具の仕上げを丁寧に。ギアを保管するスペースもDIYでおしゃれに、アイデアを練っては、あれこれ作ってみる時間を楽しんでるよう。`;
      }
    });

    let swiperBtn = document.getElementById("jsSwiperPlanBtn")
    let btn = swiperBtn.querySelectorAll('.btn');
    for (let i = 0; i < btn.length; i++){
      btn[i].addEventListener('click', () => {
        if(i == 0){
          swiper.slideToLoop(0)
        }
        if(i == 1){
          swiper.slideToLoop(1)
        }
        if(i == 2){
          swiper.slideToLoop(2)
        }
        if(i == 3){
          swiper.slideToLoop(3)
        }
      });
    }


  }
})();
export default dpPlan;